import { ref, computed } from 'vue'
import { defineStore } from 'pinia'
import type { BountyDto } from '@roadfootage/api-client'
import { useApi } from '../../composables/api'

export type BountySortOrder = '-createdAt' | '-rewardAmountPoints'

const PAGE_SIZE = 12

export const useBountiesStore = defineStore('bounties', () => {
  const { publicBountiesApi } = useApi()
  const bounties = ref<BountyDto[]>([])
  const sort = ref<BountySortOrder>('-createdAt')
  const isLoading = ref(false)
  const totalCount = ref(0)
  const hasMore = computed(() => bounties.value.length < totalCount.value)

  // Derived from item count so it can never drift out of sync across navigations.
  const nextPage = computed(() => Math.floor(bounties.value.length / PAGE_SIZE) + 1)

  async function fetchBounties() {
    if (isLoading.value) return
    isLoading.value = true
    try {
      const response = await publicBountiesApi.publicBountiesGetPublicBounties({
        page: nextPage.value,
        pageSize: PAGE_SIZE,
        sort: sort.value
      })
      bounties.value.push(...(response.items ?? []))
      totalCount.value = response.totalCount ?? totalCount.value
    } catch (error) {
      console.error('Failed to fetch bounties', error)
    } finally {
      isLoading.value = false
    }
  }

  function reset() {
    bounties.value = []
    totalCount.value = 0
  }

  return { bounties, sort, isLoading, hasMore, fetchBounties, reset }
})
